export const fileExtensionsToMimeTypes: Record<string, string> = {
	'3gp': 'video/3gpp',
};

export const getMimeTypeByFile = (file: any) => {
	if (file.type) {
		return file.type;
	}

	const extension = file.name?.split('.')?.pop()?.toLowerCase();

	if (extension && fileExtensionsToMimeTypes[extension]) {
		return fileExtensionsToMimeTypes[extension];
	}

	return '';
};
